import './styles.scss'
import React from 'react'

const StatusCircles = ({ title = '', status = [] }) => (
  <div className='status-circles'>
    <span className='status-circles__title'>{title}</span>
    <div className='status-circles__status-container'>
      {
        status.map((status, index) => {
          const exist = !!status.colorType
          const color = !['APPROVED', 'PENDING', 'REJECTED', 'DRAFT'].includes(status.colorType) ? 'DEFAULT' : status.colorType

          return (
            <div
              key={index}
              className={`
                status-circles__status
                status-circles__status--${exist ? color : 'empty'}
              `}
            >
              <strong>{status.value}</strong>
            </div>
          )
        })
      }
    </div>
  </div>
)

export default StatusCircles
